import { Promoter } from "../types/promoter";

const getPromoterFromUrl = (): string | null => {
	const url = window.location.href;
	const urlObj = new URL(url);
	const hostname = urlObj.hostname;
	const hnamelenght = hostname.split(".").length;
	const subdominio =
		hnamelenght >= 2 && hnamelenght < 4 ? hostname.split(".")[0] : null;

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const pmname = urlParams.get("pmname");

	return subdominio ? subdominio : pmname;
};

export const getPromoterService = async (): Promise<Promoter> => {
	const promoter = getPromoterFromUrl(); // Obtener el valor del promoter desde la URL
	/*
  try {
    const response = require(`../content/promoters/${promoter}.json`);
    return response;
  } catch(error) {
    console.error('Fetch error:', error);
    throw new Error('Promoter no encontrado');
  }
  */

	const apiUrl = `${process.env.REACT_APP_API_URL}/promoter/${promoter}`;

	try {
		const response = await fetch(apiUrl);

		if (response.status === 404) {
			throw new Error("Promoter no encontrado");
		}

		if (!response.ok) {
			const errorText = await response.text();
			console.error("Error response text:", errorText);
			throw new Error("Network response was not ok");
		}
		const contentType = response.headers.get("content-type");
		if (contentType && contentType.includes("application/json")) {
			return response.json();
		} else {
			const errorText = await response.text();
			console.error("Error: Expected JSON but received:", errorText);
			throw new Error("Received non-JSON response");
		}
	} catch (error) {
		console.error("Fetch error:", error);
		throw error;
	}
};
